import { motion } from 'framer-motion';

const TOMMY_IMAGE = "https://customer-assets.emergentagent.com/job_agent-jobs-hub/artifacts/8k1sk2pq_359.jpg";

export const Tommy = ({ 
  size = 'md', 
  message = null, 
  animate = true,
  className = '' 
}) => {
  const sizes = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32',
    xl: 'w-48 h-48'
  };

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <motion.div
        className={`${sizes[size]} rounded-full overflow-hidden border-4 border-indigo-500/30 shadow-[0_0_20px_rgba(99,102,241,0.3)]`}
        animate={animate ? { y: [0, -8, 0] } : {}}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      >
        <img 
          src={TOMMY_IMAGE} 
          alt="Tommy The Tuxedo Cat - NexusAI Mascot" 
          className="w-full h-full object-cover"
        />
      </motion.div>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-3 bg-zinc-800/80 backdrop-blur-sm border border-white/10 rounded-xl px-4 py-2 max-w-xs"
        >
          <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-3 h-3 bg-zinc-800 border-l border-t border-white/10 rotate-45" />
          <p className="text-sm text-zinc-300 text-center relative">{message}</p>
        </motion.div>
      )}
    </div>
  );
};

export const TommyBadge = () => (
  <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-indigo-500/10 border border-indigo-500/30 rounded-full">
    <div className="w-6 h-6 rounded-full overflow-hidden">
      <img 
        src={TOMMY_IMAGE} 
        alt="Tommy" 
        className="w-full h-full object-cover"
      />
    </div>
    <span className="text-xs font-medium text-indigo-400">Tommy Approved</span>
  </div>
);

export const TommyLoading = ({ text = "Tommy is working on it..." }) => (
  <div className="flex flex-col items-center justify-center py-12">
    <motion.div
      className="w-20 h-20 rounded-full overflow-hidden border-4 border-cyan-500/30"
      animate={{ 
        rotate: [0, 5, -5, 0],
        scale: [1, 1.05, 1]
      }}
      transition={{ duration: 1.5, repeat: Infinity }}
    >
      <img 
        src={TOMMY_IMAGE} 
        alt="Tommy Loading" 
        className="w-full h-full object-cover"
      />
    </motion.div>
    <motion.p
      className="mt-4 text-zinc-400 text-sm"
      animate={{ opacity: [0.5, 1, 0.5] }}
      transition={{ duration: 1.5, repeat: Infinity }}
    >
      {text}
    </motion.p>
  </div>
);

export const TommyEmptyState = ({ 
  title, 
  description, 
  action = null 
}) => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
    <Tommy size="lg" animate={true} />
    <h3 className="mt-6 text-xl font-semibold text-white">{title}</h3>
    <p className="mt-2 text-zinc-400 max-w-md">{description}</p>
    {action && <div className="mt-6">{action}</div>}
  </div>
);

export default Tommy;
